import type { ISerialize } from '@/objects/ISerialize';

export class SignalrUnknownTagSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrUnknownTagSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrUnknownTagSubscribeParameters {
        return new SignalrUnknownTagSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrUnknownTagSubscribeParameters {
        return new SignalrUnknownTagSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrUnknownTagSubscribeParameters from another instance of SignalrUnknownTagSubscribeParameters.
     * @param other The SignalrUnknownTagSubscribeParameters you want to clone
     * @returns A cloned SignalrUnknownTagSubscribeParameters
     */
    public static FromOther(other: SignalrUnknownTagSubscribeParameters): SignalrUnknownTagSubscribeParameters {
        return SignalrUnknownTagSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrUnknownTagSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrUnknownTagSubscribeParameters';
}
